export const regexpYoutubeLink = /^.*(youtu.be\/|v\/|e\/|u\/\w+\/|embed\/|v=)([^#\\&\\?]*).*/;
export const query = '?enablejsapi=1&rel=0&showinfo=0&autoplay=1';
